import { getCarImageSources } from "@/data/car-images";
import { cn } from "@/lib/utils";

/**
 * Renders a fleet photo using responsive WebP variants when available,
 * falling back to the original PNG for any image without variants.
 */
export function CarPhoto({
  src,
  alt,
  className,
  sizes = "(min-width: 1024px) 400px, (min-width: 640px) 50vw, 100vw",
  loading = "lazy",
  fetchPriority,
}: {
  src: string | undefined;
  alt: string;
  className?: string;
  sizes?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
}) {
  const variants = getCarImageSources(src);

  return (
    <img
      src={variants?.src ?? src ?? ""}
      srcSet={variants?.srcSet}
      sizes={variants ? sizes : undefined}
      alt={alt}
      loading={loading}
      decoding={loading === "eager" ? "sync" : "async"}
      fetchPriority={fetchPriority}
      width={800}
      height={392}
      className={cn("photo-stage-img", className)}
    />
  );
}
